import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { Article } from '../../model/article';
import { ArticleService } from '../../service/data/article.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ArticleCommandHandlerResolver } from '../../service/command/article-command-handler-resolver.service';
import { articleCommand } from '../../command/article.command';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { AdjustmentKind, AdjustmentKindToString } from '../../model/const/enums';

@Component({
    selector: 'app-article-manager',
    templateUrl: './article-manager.component.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [ArticleCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleMultiSelectManagerComponent extends MultiselectObjectManagerComponentBase<Article> {
  adjustments = [
    { caption: 'ALL_TEXT', value: null },
    { caption: AdjustmentKindToString(AdjustmentKind.None), value: AdjustmentKind.None },
    { caption: AdjustmentKindToString(AdjustmentKind.Free), value: AdjustmentKind.Free },
    { caption: AdjustmentKindToString(AdjustmentKind.Negotiation), value: AdjustmentKind.Negotiation },
    { caption: AdjustmentKindToString(AdjustmentKind.Index), value: AdjustmentKind.Index },
    { caption: AdjustmentKindToString(AdjustmentKind.FixedPercentage), value: AdjustmentKind.FixedPercentage },
    { caption: AdjustmentKindToString(AdjustmentKind.FeeToBrf), value: AdjustmentKind.FeeToBrf },
  ];
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: ArticleService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ArticleCommandHandlerResolver
  ) {
    super(_dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('Article');
    this.title = 'ARTICLE_LIST.HEADER';
    this.menuDefinition = [new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.EXPORT', articleCommand.export)];
    this.preferencesKey = 'rent.article-manager.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'ARTICLE.CAPTION',
            'captionContains',
            definition.captionContains,
            null,
            definition.selectedFields.includes('captionContains')
          ),
          new FilterDefinitionItem('ARTICLE.CODE', 'code', definition.code, null, definition.selectedFields.includes('code')),
          new FilterDefinitionItem(
            'ARTICLE.ADJUSTMENT',
            'adjustment',
            definition.adjustment,
            this.adjustments,
            definition.selectedFields.includes('adjustment')
          ),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}

function getAdjustments(): any[] {
  throw new Error('Function not implemented.');
}
